import { useEffect } from "react"
import { useStudentsFilters, useStudentsStore } from "../store/studentsStore"
import { useAccessAPI } from "./useAccessAPI"
import StudentsService from "../API/StudentsService"
import { useGlobalStore } from "../store/globalStore"

export const useMyStudents = () => {
    const user = useGlobalStore(state => state.user)
    const [students, setStudents] = useStudentsStore(state => [state.students, state.setStudents])
    const filters = useStudentsFilters(state => state.filters)
    const getStudents = useAccessAPI(StudentsService.getStudents)

    useEffect(() => {
        async function fetchMyStudents() {
            const response = await getStudents(user?.role?.identifier, filters)
            if (response?.status === 200)
                setStudents(response.data)
        }

        if (students.length < 1) {
            fetchMyStudents()
        }
    }, [])
}
